<div class="container news-feed padding0" *ngIf="isDataAvailable">
  <h2>{{ newsData.pageName }}</h2>
  <div class="news-block" *ngFor="let news of newsData.newsFeed">
    <h4>
      {{ news.title }} <span>{{ news.date | date: 'MM/dd/yyyy' }}</span>
    </h4>
    <img
      [ngClass]="{
        'margin-right50': news.align == 'left',
        'margin-left50': news.align == 'right'
      }"
      [src]="news.image?.Src"
      [align]="news.align"
    />
    <div [innerHTML]="news.text"></div>
  </div>
</div>
